export default __webpack_public_path__ + "static/media/android-icon-white.630e8f7c.webp";